import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { list, reset, pick } from '../../actions/song/available';
import { success } from '../../actions/song/delete';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    songTitle: {
        marginRight: '4em'
    }
});

class Available extends Component {
    static propTypes = {
        error: PropTypes.string,
        loading: PropTypes.bool.isRequired,
        data: PropTypes.object.isRequired,
        list: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        picked: PropTypes.object
    };

    componentDidMount() {
        this.props.list();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        if (this.props.picked) return <Redirect to="/" />;

        const songs = this.props.data['hydra:member'];
        const { classes, pick } = this.props;

        return (
            <div>
                {songs &&
                    songs.length > 0 && (
                        <div>
                            <h1>Available Songs</h1>

                            {this.props.error && (
                                <div className="alert alert-danger">
                                    {this.props.error}
                                </div>
                            )}

                            <List>
                                {songs.map(song => (
                                    <ListItem key={song['@id']} button>
                                        <ListItemText
                                            primary={song['title']}
                                            className={classes.songTitle}
                                        />
                                        <ListItemSecondaryAction>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                onClick={() => pick(song['id'])}
                                            >
                                                Add
                                            </Button>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    )}

                {this.props.loading && (
                    <div className="alert alert-info">Loading...</div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state.song.available.data,
        error: state.song.available.error,
        loading: state.song.available.loading,
        picked: state.song.available.picked
    };
};

const mapDispatchToProps = dispatch => {
    return {
        list: page => dispatch(list(page)),
        pick: songId => dispatch(pick(songId)),
        reset: () => {
            dispatch(reset());
            dispatch(success(null));
        }
    };
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Available)
);



// WEBPACK FOOTER //
// ./src/components/song/Available.js